module.exports = "/static/assets/9c43d786f5c08113feaeafb87275974a.png";